"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

exports.__esModule = true;
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

var P = _interopRequireWildcard(require("@react-pdf/primitives"));

var isRect = R.propEq('type', P.Rect);
var _default = isRect;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@react-pdf/render/lib/utils/isRect.js
// module id = 222
// module chunks = 0